<template>
    <v-dialog :model-value="modelValue" max-width="500px" persistent>
        <v-card>
            <v-card class="v-card-100 mt-0 custom-shadow">
            <v-card-title class="pa-0">
                <v-row class="ma-2">
                <span class="font-weight-bold">Upload</span>
                <v-spacer></v-spacer>
                <v-icon @click="onCancel">mdi-close</v-icon>
                </v-row>
            </v-card-title>
            </v-card>
             <div style="text-align: right; padding:8px; font-weight: 600; color: #0357D0"><span><a @click="downloadSampleFile">Download Sample File</a></span></div>
            <v-card-text>
                <v-file-input
                    v-model="file"
                    :accept="acceptedFormats"
                    :error="fileError"
                    :error-messages="fileErrorMessage"
                    label="Attach the CSV file"
                    variant="outlined"
                    prepend-inner-icon="mdi-paperclip"
                    prepend-icon=""
                    @change="changeFile"
                ></v-file-input>
                <!-- Progress bar -->
                <v-progress-linear
                   v-if="uploading"
                   indeterminate
                   color="primary"
                   class="mt-3"
                ></v-progress-linear>
                <!-- Status -->
                <div v-if="uploadCompleted" class="text-green" style="text-align: end; font-weight: bold">
                  Completed!
                </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn v-if="uploadCompleted" variant="flat" color="primary" class="text-none" @click="onFinish">Finish</v-btn>
                <v-btn v-else variant="flat" color="primary" class="text-none" :disabled="!file || fileError" @click="onUpload">Confirm</v-btn>
                <v-btn variant="outlined" class="text-none" color="primary" @click="onCancel">Cancel</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script setup>
import { mergeProps, ref, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router'

const props = defineProps({
    dialog: Boolean,
    apiUrl: String,
    data: Object
})
const emit = defineEmits(["update:modelValue"]);
const store = useStore();
const route = useRoute();
const router = useRouter();
const { proxy } = getCurrentInstance();
const modelValue = ref(false);
const file = ref(null);
const uploading = ref(false);
const uploadCompleted = ref(false);
const acceptedFormats = ref('.csv');
const fileError = ref(false);
const fileErrorMessage = ref('');
const number = ref(0);

const onUpload = async () => {
  number.value++;
  uploading.value = true;
  uploadCompleted.value = false;

  const formData = new FormData();
  formData.append("master_file", file.value);
  formData.append("master_file_type", props.data?.master_file_type);
  formData.append("file_type_name", props.data?.file_type_name);

  proxy.$httpSecured
    .post(props.apiUrl, formData)
    .then((response) => {
      number.value = 0;
      uploading.value = false;
      uploadCompleted.value = true;
      console.log("Upload success:", response.data);
    })
    .catch((error) => {
      number.value = 0;
      uploading.value = false;
      uploadCompleted.value = false;
      proxy.$toast.error(error.response.data.error);
    });
};

const onFinish = () => {
  modelValue.value = false;
  store.commit("setLotIds", {
         lotIds: props.data.file_type_name,
         action:props.data,
         inventoryId: props.data.header_text
        });
  router.push({ name: "LotFileuploadComm" });
};

const onCancel = () => {
  emit("update:modelValue", false);
};

const changeFile = (event) => {
   if(file.value){
     const fileType = file.value.type;
     if (fileType !== 'text/csv') {
        fileError.value = true;
        fileErrorMessage.value = 'Only CSV files are allowed.';
     } else {
        fileError.value = false;
        fileErrorMessage.value = '';
     }
   }
};
const downloadSampleFile = () => {
  const formData = new FormData();
  formData.append("only_headers", true);
  formData.append("file_type_name", props.data?.file_type_name);
  const api = props.data.sample_file_url;
  proxy.$httpSecured
    .post(api, formData)
    .then((response) => {
       const link = document.createElement('a');
       link.href = response.data.url; 
       link.target = '_blank';
       link.download = 'sample_file.csv'; 
       document.body.appendChild(link);
       link.click();
      proxy.$toast.success("Downloaded Successfully!");
    })
    .catch((error) => {
      number.value = 0;
      proxy.$toast.error(error.response.data.message);
    });
};

</script>